import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import { PwaAutoUpdate } from "./components/PwaAutoUpdate";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
      {/* Inside the router: a route change is the safe moment to apply a held update. */}
      <PwaAutoUpdate />
    </BrowserRouter>
  </StrictMode>,
);
